import * as React from "react";

const AdthriveContent = () => {

    return (
        <div className="mkcontainer-content">
            <div className="adthrive-placeholder-content"/>
        </div>
    );
}

export default AdthriveContent;

